import { render, staticRenderFns } from "./CategorySkeleton.vue?vue&type=template&id=be51bc22&scoped=true"
import script from "./CategorySkeleton.vue?vue&type=script&lang=js"
export * from "./CategorySkeleton.vue?vue&type=script&lang=js"
import style0 from "./CategorySkeleton.vue?vue&type=style&index=0&id=be51bc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be51bc22",
  null
  
)

export default component.exports